import { ActivityIndicator, ScrollView, View } from "react-native";
import {
  FIREBASE_EVENT_NAMES,
  FIREBASE_EVENT_PARAMS,
  PAGES_ROUTES,
  PAGES_TITLE,
} from "utils/Constants";
import { fp, hp, normalize, spH, spV, wp } from "utils/normalise";
import {
  setBillingAddress,
  setDeliveryAddress,
} from "appRedux/reducers/orderSlice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";

import Buttons from "components/Buttons";
import CheckoutCard from "components/checkout/CheckoutCard";
import { Colors } from "colors";
import ParentScrollView from "components/ParentScrollView";
import VText from "components/VText";
import { analytics } from "utils/firebaseConfig";
import { getCart } from "appRedux/reducers/cartSlice";
import { getFormatedCurrency } from "utils/common";
import { logEvent } from "firebase/analytics";
import { router, useLocalSearchParams } from "expo-router";
import { trackV2 } from "utils/Segment";
import { ANALYTICS_EVENT_NAMES } from "utils/analytics";
import EmptyScreen from "components/emptyScreen";
import { Svg as Svgs } from "assets/svg";

const Checkout = () => {
  const [cart, setCart] = useState();
  const [loading, setLaoding] = useState(false);
  const [isAllOutOfStock, setIsAllOutOfStock] = useState(true);

  const cartRedux = useSelector((state) => state.CartReducer.cart);
  const userId = useSelector((state) => state.AuthReducer.userId);
  const _loginModalRef = useSelector(
    (state) => state.UtilsReducer._loginModalRef
  );
  const countrySymbol = useSelector(
    (state) => state.StoredutilsSlice.countrySymbol
  );
  const local = useLocalSearchParams();
  const localGender = local?.gender || "female";
  const dispatch = useDispatch();
  const [isAllAvailable, setIsAllAvailable] = useState(false);

  useEffect(() => {
    const eventData = {
      products_count: cart?.cart?.length,
      total_value: cart?.orderSummary?.totalAmount,
      products: cart?.cart,
    };
    if (cart?.cart?.length > 0) {
      trackV2(ANALYTICS_EVENT_NAMES.BAG_SUMMARY_VIEWED, eventData);
    }
  }, [cart?.cart]);

  useEffect(() => {
    setLaoding(true);
    dispatch(getCart())
      .then((res) => {
        if ([200].includes(res?.payload?.status) && res?.payload?.data?.cart) {
          setCart(res?.payload?.data);
        }
        setLaoding(false);
      })
      .catch((err) => {
        setLaoding(false);
        alert("Error");
      });
  }, []);

  useEffect(() => {
    setCart(cartRedux);
  }, [cartRedux]);

  useEffect(() => {
    if (cart?.cart && Array.isArray(cart?.cart)) {
      if (cart?.cart?.filter((o) => o?.regionAvailability === false)?.length) {
        setIsAllAvailable(true);
      } else {
        setIsAllAvailable(false);
      }

      if (cart?.cart?.filter((o) => o?.isAvailable)?.length == 0) {
        setIsAllOutOfStock(true);
      } else {
        setIsAllOutOfStock(false);
      }
    } else {
      setIsAllOutOfStock(false);
    }
  }, [cart?.cart]);

  if (loading) {
    return (
      <ParentScrollView>
        <View
          style={{
            width: "100%",
            height: 500,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <ActivityIndicator size={40} color={Colors.black} />
        </View>
      </ParentScrollView>
    );
  }

  if (cart?.cart?.length == 0) {
    return (
      <ParentScrollView>
        <EmptyScreen
          icon={Svgs.shoppingBag}
          title="Your shopping bag is currently empty."
          buttonText="Shop What’s New"
          onPress={() =>
            router.push(
              `${
                localGender == "men" ? "/men" : ""
              }/shop/all-new-arrivals?optionId=1&title=All+New+Arrivals`
            )
          }
        />
      </ParentScrollView>
    );
  }

  return (
    <ParentScrollView>
      <View
        style={{
          flex: 1,
          paddingHorizontal: spH(80),
          paddingBottom: spV(40),
          flexDirection: "row",
          marginTop: spV(32),
        }}
      >
        <View
          style={{
            width: wp(650),
            marginRight: wp(56),
          }}
        >
          <VText
            style={{
              fontSize: fp(20),
              paddingBottom: spV(16),
              borderBottomWidth: 1,
              borderColor: "rgba(33, 36, 39, 0.3)",
              marginBottom: spV(16),
              fontFamily: "LibreBodoni",
              fontWeight: "350",
            }}
            text={`Shopping Bag (${
              Array.isArray(cart?.cart)
                ? cart?.cart?.reduce(
                    (accumulator, currentValue) =>
                      accumulator + currentValue?.quantity,
                    0
                  )
                : 0
            })`}
          />
          {Array.isArray(cart?.cart) &&
            cart?.cart?.map((o, idx) => (
              <View
                style={{
                  opacity: o?.isAvailable ? 1 : 0.6,
                }}
                key={idx}
              >
                <CheckoutCard
                  containerStyle={{
                    borderBottomWidth: 1,
                    paddingBottom: spV(16),
                    borderColor: "rgba(33, 36, 39, 0.3)",
                  }}
                  hideCross={false}
                  hideOptions={!o?.isAvailable}
                  key={idx}
                  isCheckout={true}
                  cartItem={o}
                  sizeTextStyle={{
                    width: "25%",
                  }}
                />
              </View>
            ))}
        </View>
        <View
          style={{
            flex: 1,
          }}
        >
          <VText
            style={{
              fontSize: fp(20),
              paddingBottom: spV(16),
              borderBottomWidth: 1,
              borderColor: "rgba(33, 36, 39, 0.3)",
              marginBottom: spV(16),
              textAlign: "right",
              fontFamily: "LibreBodoni",
            }}
            text={`Price Summary`}
          />
          <View>
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                paddingBottom: spV(16),
              }}
            >
              <VText
                style={{
                  fontSize: fp(14),
                  fontWeight: "350",
                }}
                text={`Subtotal`}
              />
              <VText
                style={{
                  fontSize: fp(14),
                  color: "#212427",
                  fontWeight: "350",
                }}
                text={`${countrySymbol}${getFormatedCurrency(
                  cart?.orderSummary?.totalAmount
                )}`}
              />
            </View>
            {/* <View
                        style={{
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "space-between",
                            paddingBottom: spV(16),
                        }}
                    >
                        <VText
                            style={{
                                fontSize: fp(16),
                            }}
                            text={`Shipping Charges`}
                        />
                        <VText
                            style={{
                                fontSize: fp(16),
                                color: "#212427",
                            }}
                            text={`$${getFormatedCurrency(cart?.orderSummary?.deliveryCharge)}`}
                        />
                    </View>
                    <View
                        style={{
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "space-between",
                            paddingBottom: spV(16),
                            borderBottomWidth: 1,
                            borderColor: "rgba(33, 36, 39, 0.3)",
                        }}
                    >
                        <VText
                            style={{
                                fontSize: fp(16),
                            }}
                            text={`Sales Tax`}
                        />
                        <VText
                            style={{
                                fontSize: fp(16),
                                color: "#212427",
                            }}
                            text={`$${getFormatedCurrency(cart?.orderSummary?.taxAmount)}`}
                        />
                    </View> */}
            {/* <View
                        style={{
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "space-between",
                            paddingTop: spV(16),
                            marginBottom: spV(28),
                        }}
                    >
                        <VText
                            style={{
                                fontSize: fp(16),
                                fontWeight: "bold",
                            }}
                            text={`Order Total`}
                        />
                        <VText
                            style={{
                                fontSize: fp(16),
                                color: "#212427",
                                fontWeight: "bold",
                            }}
                            text={`$${getFormatedCurrency(cart?.orderSummary?.payableAmount)}`}
                        />
                    </View> */}
            <Buttons
              disabled={isAllOutOfStock || isAllAvailable === true}
              onPress={() => {
                if (!userId) {
                  const eventData = {
                    user_action: userId ? "login" : "continue_as_guest",
                  };
                  trackV2(
                    ANALYTICS_EVENT_NAMES.CHECKOUT_USER_DECISION,
                    eventData
                  );
                  _loginModalRef?.current?.show(true);
                  return;
                }
                if (!isAllOutOfStock) {
                  dispatch(setDeliveryAddress());
                  dispatch(setBillingAddress());
                  const eventData = {
                    user_status: "logged_in",
                    bag_product_count: cart?.cart?.length,
                    bag_total_value: cart?.orderSummary?.totalAmount,
                  };
                  trackV2(
                    ANALYTICS_EVENT_NAMES.PROCEED_TO_CHECKOUT_CLICKED,
                    eventData
                  );
                  router.push(
                    `${localGender == "men" ? "/men" : ""}/addresslist`
                  );
                }
              }}
              containerStyle={{
                opacity: isAllOutOfStock || isAllAvailable === true ? 0.3 : 1,
                padding: normalize(12),
                height: hp(44),
              }}
              textStyle={{
                fontSize: fp(16),
                fontWeight: "350",
              }}
              text="Proceed To Checkout"
            />
          </View>
        </View>
      </View>
    </ParentScrollView>
  );
};

export default Checkout;
